<template>
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M0.645132 5.2752C0.645132 5.1139 0.70672 4.95262 0.829635 4.82965L4.69948 0.959843C4.94565 0.713673 5.34477 0.713673 5.59084 0.959843C5.83691 1.20591 5.83691 1.60496 5.59084 1.85115L2.16659 5.2752L5.59072 8.69927C5.83679 8.94544 5.83679 9.34445 5.59072 9.5905C5.34465 9.83679 4.94553 9.83679 4.69936 9.5905L0.829515 5.72075C0.70658 5.59772 0.645132 5.43644 0.645132 5.2752Z"
      fill="#87939E"/>
</svg>
</template>
